module.exports = __webpack_public_path__ + "img/solin.0f7f84cc.png";